<template>
  <SocialMarketingCardContainer
    class="bg-charcoal"
    :inProgress="inProgress"
    size="story"
  >
    <SocialMarketingImage
      class="flex-1"
      :userImage="marketingAsset.image"
      :editMode="editMode"
    />
    <div
      class="card-p-3 flex-1 d-flex flex-column justify-content-between position-relative"
      :class="{
        'card-pt-4': profilePhoto,
      }"
    >
      <SocialMarketingStudioImage :profilePhoto="profilePhoto" />
      <SocialMarketingStudioContent
        :title="marketingAsset.title"
        :description="marketingAsset.description"
        colorType="light"
        :descriptionMaxLines="7"
      />
      <SocialMarketingStudioInfo
        :showProfilePhoto="false"
        class="card-mt-3"
        :color="cardColorType"
        :studioUrl="studioUrl"
      />
    </div>
  </SocialMarketingCardContainer>
</template>

<script>
import SocialMarketingCardContainer from '@/web/components/marketing/SocialMarketingCardContainer.vue';
import SocialMarketingStudioInfo from '@/web/components/marketing/SocialMarketingStudioInfo.vue';
import SocialMarketingStudioContent from '@/web/components/marketing/SocialMarketingStudioContent.vue';
import SocialMarketingImage from '@/web/components/marketing/SocialMarketingImage.vue';
import SocialMarketingStudioImage from '@/web/components/marketing/SocialMarketingStudioImage.vue';
import { isBrightColor } from '@/web/utils/colors.js';

export default {
  name: 'Template7',
  components: {
    SocialMarketingCardContainer,
    SocialMarketingStudioInfo,
    SocialMarketingStudioContent,
    SocialMarketingImage,
    SocialMarketingStudioImage,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    inProgress: {
      type: Boolean,
      default: false,
    },
    isDownload: {
      type: Boolean,
      default: false,
    },
    studioUrl: {
      type: String,
      default: '',
    },
    profilePhoto: {
      type: String,
      default: '',
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    marketingAsset() {
      return this.value;
    },
    cardColorType() {
      return isBrightColor(this.marketingAsset?.primary_color)
        ? 'dark-opacity'
        : 'light';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
